module.exports = __webpack_public_path__ + "media/images/icons/circle-x-34951dc1868dba0086c8bdb7c990d55a.svg";